module.exports = __webpack_public_path__ + "static/media/no-order.3b13ed19.svg";